import colors from "../colors";

export default colors("8dd3c7ffffb3bebadafb807280b1d3fdb462b3de69fccde5d9d9d9bc80bdccebc5ffed6f");



//////////////////
// WEBPACK FOOTER
// ../~/d3-scale-chromatic/src/categorical/Set3.js
// module id = XNXw
// module chunks = 0